import {fromUnixTime} from 'date-fns';
import Long from 'long';

export default function unixDate(stamp?: Long | null): Date {
  return fromUnixTime(stamp?.toNumber() || 0);
}